function convertString(arg: object | number | string) {
  if (Object.prototype.toString.call(arg) === `[object Object]`) {
    return JSON.stringify(arg);
  } else if (typeof arg === `number`) {
    return arg.toString();
  } else {
    return arg;
  }
}

export function areArraysEqual(
  arr1: (object | string | number)[] = [],
  arr2: (object | string | number)[] = [],
) {
  if (arr1.length === arr2.length) {
    return arr1.every((item) => {
      return arr2.some(
        (entity) => convertString(item) === convertString(entity),
      );
    });
  }
  return false;
}
